import * as React from 'react';
import { provideReactWrapper } from '@ni/fast-react-wrapper';

export const { wrap } = provideReactWrapper(React);
